<a mat-list-item *appAuthorize="sidenavItem.authorize" [routerLink]="sidenavItem.route" class="sidenav-item">
  <mat-icon class="mr-2">{{ sidenavItem.icon }}</mat-icon> {{ sidenavItem.title }}
</a>
